import { Pipe, PipeTransform } from '@angular/core';
import { CustomProductAttributeConfig } from '@ui/products/types';
import {
  ConfigPickerFromPhotographerCounter,
  ConfigPickerFromPhotographerPreConfig,
} from '@ui/products/products-front/components/config-picker-from-photographer-pre-config/types';

@Pipe({
    name: 'calculateMinValueIncludingPhotographerConfig',
    standalone: false
})
export class CalculateMinValueIncludingPhotographerConfigPipe
  implements PipeTransform
{
  transform(
    value: CustomProductAttributeConfig,
    photographerConfig: ConfigPickerFromPhotographerPreConfig
  ): unknown {
    if (!photographerConfig) {
      return value.counterConfig.min;
    }
    return (
      photographerConfig[value.customId] as ConfigPickerFromPhotographerCounter
    ).currentMinValue;
  }
}
